import { IEmailFamily } from "../../../models/index"

export interface IEmailFamilyState {
    list: IEmailFamily[];
}